import { required } from 'vuelidate/lib/validators'

const validaDuration = value => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true
  }
  return /^(?:(?:([01]?\d|2[0-3]):)?([0-5]?\d):)?([0-5]?\d)$/g.test(value)
}

export const validateData = {
  form: {
    filas: { required },
  },
  maiorQue: { validaDuration },
  menorQue: { validaDuration },
}

export const validateComputed = {
  filasErrors() {
    const errors = []
    if (!this.$v.form.filas.$dirty) return errors
    !this.$v.form.filas.required && errors.push('Campo obrigatório.')
    return errors
  },
  maiorQueErrors() {
    const errors = []
    if (!this.$v.maiorQue.$dirty) return errors
    !this.$v.maiorQue.validaDuration && errors.push('Formato inválido')
    return errors
  },
  menorQueErrors() {
    const errors = []
    if (!this.$v.menorQue.$dirty) return errors
    !this.$v.menorQue.validaDuration && errors.push('Formato inválido')
    return errors
  },
}
